export default "__VITE_ASSET__cQuW7CI1__"